import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      // Bovenin, want onderin liggen de tabbalk en de knoppen waar je net op
      // drukte: daar dekt een toast precies af waar je mee bezig bent. De
      // hoogte en breedte zitten in styles/index.css, zie het blok "Sonner".
      position="top-center"
      // Drie seconden is lang genoeg om een regel te lezen en kort genoeg om
      // niet in de weg te blijven hangen.
      duration={3000}
      // Meer dan twee tegelijk is geen informatie meer maar een stapel.
      visibleToasts={2}
      gap={8}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-txt-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
